/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/horse_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./horse_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient =
  function HorseServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient =
  function HorseServicePromiseClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetHorseRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_GetHorse = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.HorseService/GetHorse",
  grpc.web.MethodType.UNARY,
  stronachgroup_first_racehorse360_messages_pb.GetHorseRequest,
  stronachgroup_first_racehorse360_messages_pb.Horse,
  /**
   * @param {!proto.stronachgroup.first.racehorse360.GetHorseRequest} request
   * @return {!Uint8Array}
   */
  function (request) {
    return request.constructor.encode(request).finish();
  },
  stronachgroup_first_racehorse360_messages_pb.Horse.decode
);

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetHorseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.getHorse =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/GetHorse",
      request,
      metadata || {},
      methodDescriptor_HorseService_GetHorse,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetHorseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.getHorse =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/GetHorse",
      request,
      metadata || {},
      methodDescriptor_HorseService_GetHorse
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListHorsesRequest,
 *   !proto.stronachgroup.first.racehorse360.ListHorsesResponse>}
 */
const methodDescriptor_HorseService_ListHorses = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.HorseService/ListHorses",
  grpc.web.MethodType.UNARY,
  stronachgroup_first_racehorse360_messages_pb.ListHorsesRequest,
  stronachgroup_first_racehorse360_messages_pb.ListHorsesResponse,
  /**
   * @param {!proto.stronachgroup.first.racehorse360.ListHorsesRequest} request
   * @return {!Uint8Array}
   */
  function (request) {
    return request.constructor.encode(request).finish();
  },
  stronachgroup_first_racehorse360_messages_pb.ListHorsesResponse.decode
);

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorsesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListHorsesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListHorsesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.listHorses =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorses",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListHorses,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorsesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListHorsesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.listHorses =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorses",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListHorses
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.AssignHorseToBarnRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_AssignHorseToBarn =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/AssignHorseToBarn",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.AssignHorseToBarnRequest,
    stronachgroup_first_racehorse360_messages_pb.Horse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.AssignHorseToBarnRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Horse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.AssignHorseToBarnRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.assignHorseToBarn =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/AssignHorseToBarn",
      request,
      metadata || {},
      methodDescriptor_HorseService_AssignHorseToBarn,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.AssignHorseToBarnRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.assignHorseToBarn =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/AssignHorseToBarn",
      request,
      metadata || {},
      methodDescriptor_HorseService_AssignHorseToBarn
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_UnassignHorseFromBarn =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromBarn",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.UnassignHorseFromBarnRequest,
    stronachgroup_first_racehorse360_messages_pb.Horse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Horse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.unassignHorseFromBarn =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromBarn",
      request,
      metadata || {},
      methodDescriptor_HorseService_UnassignHorseFromBarn,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.unassignHorseFromBarn =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromBarn",
      request,
      metadata || {},
      methodDescriptor_HorseService_UnassignHorseFromBarn
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.AssignHorseToFacilityRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_AssignHorseToFacility =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/AssignHorseToFacility",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.AssignHorseToFacilityRequest,
    stronachgroup_first_racehorse360_messages_pb.Horse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.AssignHorseToFacilityRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Horse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.AssignHorseToFacilityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.assignHorseToFacility =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/AssignHorseToFacility",
      request,
      metadata || {},
      methodDescriptor_HorseService_AssignHorseToFacility,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.AssignHorseToFacilityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.assignHorseToFacility =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/AssignHorseToFacility",
      request,
      metadata || {},
      methodDescriptor_HorseService_AssignHorseToFacility
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.AssignHorseToStallRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_AssignHorseToStall =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/AssignHorseToStall",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.AssignHorseToStallRequest,
    stronachgroup_first_racehorse360_messages_pb.Horse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.AssignHorseToStallRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Horse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.AssignHorseToStallRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.assignHorseToStall =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/AssignHorseToStall",
      request,
      metadata || {},
      methodDescriptor_HorseService_AssignHorseToStall,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.AssignHorseToStallRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.assignHorseToStall =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/AssignHorseToStall",
      request,
      metadata || {},
      methodDescriptor_HorseService_AssignHorseToStall
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.UnassignHorseFromStallRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_UnassignHorseFromStall =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromStall",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.UnassignHorseFromStallRequest,
    stronachgroup_first_racehorse360_messages_pb.Horse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.UnassignHorseFromStallRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Horse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.UnassignHorseFromStallRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.unassignHorseFromStall =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromStall",
      request,
      metadata || {},
      methodDescriptor_HorseService_UnassignHorseFromStall,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.UnassignHorseFromStallRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.unassignHorseFromStall =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromStall",
      request,
      metadata || {},
      methodDescriptor_HorseService_UnassignHorseFromStall
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.AssignHorseToTrainerRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_AssignHorseToTrainer =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/AssignHorseToTrainer",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.AssignHorseToTrainerRequest,
    stronachgroup_first_racehorse360_messages_pb.Horse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.AssignHorseToTrainerRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Horse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.AssignHorseToTrainerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.assignHorseToTrainer =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/AssignHorseToTrainer",
      request,
      metadata || {},
      methodDescriptor_HorseService_AssignHorseToTrainer,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.AssignHorseToTrainerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.assignHorseToTrainer =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/AssignHorseToTrainer",
      request,
      metadata || {},
      methodDescriptor_HorseService_AssignHorseToTrainer
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_HorseService_UnassignHorseFromTrainer =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromTrainer",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.UnassignHorseFromTrainerRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.unassignHorseFromTrainer =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromTrainer",
      request,
      metadata || {},
      methodDescriptor_HorseService_UnassignHorseFromTrainer,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.unassignHorseFromTrainer =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UnassignHorseFromTrainer",
      request,
      metadata || {},
      methodDescriptor_HorseService_UnassignHorseFromTrainer
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_AssignPreferredConditionsHorse =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/AssignPreferredConditionsHorse",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.AssignPreferredConditionsHorseRequest,
    stronachgroup_first_racehorse360_messages_pb.Horse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Horse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.assignPreferredConditionsHorse =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/AssignPreferredConditionsHorse",
      request,
      metadata || {},
      methodDescriptor_HorseService_AssignPreferredConditionsHorse,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.assignPreferredConditionsHorse =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/AssignPreferredConditionsHorse",
      request,
      metadata || {},
      methodDescriptor_HorseService_AssignPreferredConditionsHorse
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_ResetPreferredConditionsHorse =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ResetPreferredConditionsHorse",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ResetPreferredConditionsHorseRequest,
    stronachgroup_first_racehorse360_messages_pb.Horse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Horse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.resetPreferredConditionsHorse =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ResetPreferredConditionsHorse",
      request,
      metadata || {},
      methodDescriptor_HorseService_ResetPreferredConditionsHorse,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.resetPreferredConditionsHorse =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ResetPreferredConditionsHorse",
      request,
      metadata || {},
      methodDescriptor_HorseService_ResetPreferredConditionsHorse
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_EditHorseHealthWatchStatus =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/EditHorseHealthWatchStatus",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.EditHorseHealthWatchStatusRequest,
    stronachgroup_first_racehorse360_messages_pb.Horse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Horse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.editHorseHealthWatchStatus =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/EditHorseHealthWatchStatus",
      request,
      metadata || {},
      methodDescriptor_HorseService_EditHorseHealthWatchStatus,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.editHorseHealthWatchStatus =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/EditHorseHealthWatchStatus",
      request,
      metadata || {},
      methodDescriptor_HorseService_EditHorseHealthWatchStatus
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.SetHorseWarningMessageRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_SetHorseWarningMessage =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/SetHorseWarningMessage",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.SetHorseWarningMessageRequest,
    stronachgroup_first_racehorse360_messages_pb.Horse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.SetHorseWarningMessageRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Horse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetHorseWarningMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.setHorseWarningMessage =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/SetHorseWarningMessage",
      request,
      metadata || {},
      methodDescriptor_HorseService_SetHorseWarningMessage,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetHorseWarningMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.setHorseWarningMessage =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/SetHorseWarningMessage",
      request,
      metadata || {},
      methodDescriptor_HorseService_SetHorseWarningMessage
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_ResetHorseWarningMessage =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ResetHorseWarningMessage",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ResetHorseWarningMessageRequest,
    stronachgroup_first_racehorse360_messages_pb.Horse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Horse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.resetHorseWarningMessage =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ResetHorseWarningMessage",
      request,
      metadata || {},
      methodDescriptor_HorseService_ResetHorseWarningMessage,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.resetHorseWarningMessage =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ResetHorseWarningMessage",
      request,
      metadata || {},
      methodDescriptor_HorseService_ResetHorseWarningMessage
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest,
 *   !proto.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse>}
 */
const methodDescriptor_HorseService_PullRelevantHorseWarningMessage =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullRelevantHorseWarningMessage",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullRelevantHorseWarningMessageRequest,
    stronachgroup_first_racehorse360_messages_pb.PullRelevantHorseWarningMessageResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullRelevantHorseWarningMessageResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.pullRelevantHorseWarningMessage =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullRelevantHorseWarningMessage",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullRelevantHorseWarningMessage,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.pullRelevantHorseWarningMessage =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullRelevantHorseWarningMessage",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullRelevantHorseWarningMessage
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest,
 *   !proto.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse>}
 */
const methodDescriptor_HorseService_PullHorsesCountByFacilitySummary =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullHorsesCountByFacilitySummary",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullHorsesCountByFacilitySummaryRequest,
    stronachgroup_first_racehorse360_messages_pb.PullHorsesCountByFacilitySummaryResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullHorsesCountByFacilitySummaryResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.pullHorsesCountByFacilitySummary =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesCountByFacilitySummary",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullHorsesCountByFacilitySummary,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.pullHorsesCountByFacilitySummary =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesCountByFacilitySummary",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullHorsesCountByFacilitySummary
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest,
 *   !proto.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse>}
 */
const methodDescriptor_HorseService_PullTrainerHorsesWithMatchingRacesCount =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullTrainerHorsesWithMatchingRacesCount",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullTrainerHorsesWithMatchingRacesCountRequest,
    stronachgroup_first_racehorse360_messages_pb.PullTrainerHorsesWithMatchingRacesCountResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullTrainerHorsesWithMatchingRacesCountResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.pullTrainerHorsesWithMatchingRacesCount =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullTrainerHorsesWithMatchingRacesCount",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullTrainerHorsesWithMatchingRacesCount,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.pullTrainerHorsesWithMatchingRacesCount =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullTrainerHorsesWithMatchingRacesCount",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullTrainerHorsesWithMatchingRacesCount
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest,
 *   !proto.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse>}
 */
const methodDescriptor_HorseService_PullHorsesCountGroupedByPreferredConditions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullHorsesCountGroupedByPreferredConditions",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullHorsesCountGroupedByPreferredConditionsRequest,
    stronachgroup_first_racehorse360_messages_pb.PullHorsesCountGroupedByPreferredConditionsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullHorsesCountGroupedByPreferredConditionsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.pullHorsesCountGroupedByPreferredConditions =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesCountGroupedByPreferredConditions",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullHorsesCountGroupedByPreferredConditions,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.pullHorsesCountGroupedByPreferredConditions =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesCountGroupedByPreferredConditions",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullHorsesCountGroupedByPreferredConditions
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListHorseRisksRequest,
 *   !proto.stronachgroup.first.racehorse360.ListHorseRisksResponse>}
 */
const methodDescriptor_HorseService_ListHorseRisks =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ListHorseRisks",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListHorseRisksRequest,
    stronachgroup_first_racehorse360_messages_pb.ListHorseRisksResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListHorseRisksRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListHorseRisksResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListHorseRisksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListHorseRisksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.listHorseRisks =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseRisks",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListHorseRisks,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListHorseRisksResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.listHorseRisks =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseRisks",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListHorseRisks
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CreateHorseRiskRequest,
 *   !proto.stronachgroup.first.racehorse360.HorseRisk>}
 */
const methodDescriptor_HorseService_CreateHorseRisk =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/CreateHorseRisk",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CreateHorseRiskRequest,
    stronachgroup_first_racehorse360_messages_pb.HorseRisk,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CreateHorseRiskRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.HorseRisk.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateHorseRiskRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.HorseRisk)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.HorseRisk>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.createHorseRisk =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/CreateHorseRisk",
      request,
      metadata || {},
      methodDescriptor_HorseService_CreateHorseRisk,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateHorseRiskRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.HorseRisk>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.createHorseRisk =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/CreateHorseRisk",
      request,
      metadata || {},
      methodDescriptor_HorseService_CreateHorseRisk
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteHorseRiskRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_HorseService_DeleteHorseRisk =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/DeleteHorseRisk",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteHorseRiskRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseRiskRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseRiskRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.deleteHorseRisk =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/DeleteHorseRisk",
      request,
      metadata || {},
      methodDescriptor_HorseService_DeleteHorseRisk,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseRiskRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.deleteHorseRisk =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/DeleteHorseRisk",
      request,
      metadata || {},
      methodDescriptor_HorseService_DeleteHorseRisk
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListRiskFactorsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListRiskFactorsResponse>}
 */
const methodDescriptor_HorseService_ListRiskFactors =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ListRiskFactors",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListRiskFactorsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListRiskFactorsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListRiskFactorsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListRiskFactorsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListRiskFactorsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListRiskFactorsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListRiskFactorsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.listRiskFactors =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListRiskFactors",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListRiskFactors,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListRiskFactorsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListRiskFactorsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.listRiskFactors =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListRiskFactors",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListRiskFactors
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListHorseInjuriesRequest,
 *   !proto.stronachgroup.first.racehorse360.ListHorseInjuriesResponse>}
 */
const methodDescriptor_HorseService_ListHorseInjuries =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ListHorseInjuries",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListHorseInjuriesRequest,
    stronachgroup_first_racehorse360_messages_pb.ListHorseInjuriesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListHorseInjuriesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListHorseInjuriesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseInjuriesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListHorseInjuriesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListHorseInjuriesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.listHorseInjuries =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseInjuries",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListHorseInjuries,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseInjuriesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListHorseInjuriesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.listHorseInjuries =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseInjuries",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListHorseInjuries
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse>}
 */
const methodDescriptor_HorseService_ListHorseInjuryDetails =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ListHorseInjuryDetails",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListHorseInjuryDetailsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListHorseInjuryDetailsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListHorseInjuryDetailsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.listHorseInjuryDetails =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseInjuryDetails",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListHorseInjuryDetails,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.listHorseInjuryDetails =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseInjuryDetails",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListHorseInjuryDetails
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListHorseOnListsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListHorseOnListsResponse>}
 */
const methodDescriptor_HorseService_ListHorseOnLists =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ListHorseOnLists",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListHorseOnListsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListHorseOnListsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListHorseOnListsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListHorseOnListsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseOnListsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListHorseOnListsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListHorseOnListsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.listHorseOnLists =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseOnLists",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListHorseOnLists,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseOnListsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListHorseOnListsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.listHorseOnLists =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseOnLists",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListHorseOnLists
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest,
 *   !proto.stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse>}
 */
const methodDescriptor_HorseService_PullHorsesFromListsCount =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullHorsesFromListsCount",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullHorsesFromListsCountRequest,
    stronachgroup_first_racehorse360_messages_pb.PullHorsesFromListsCountResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullHorsesFromListsCountResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.pullHorsesFromListsCount =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesFromListsCount",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullHorsesFromListsCount,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.pullHorsesFromListsCount =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesFromListsCount",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullHorsesFromListsCount
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest,
 *   !proto.stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse>}
 */
const methodDescriptor_HorseService_PullHorsePreferredConditions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullHorsePreferredConditions",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullHorsePreferredConditionsRequest,
    stronachgroup_first_racehorse360_messages_pb.PullHorsePreferredConditionsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullHorsePreferredConditionsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.pullHorsePreferredConditions =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsePreferredConditions",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullHorsePreferredConditions,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.pullHorsePreferredConditions =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsePreferredConditions",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullHorsePreferredConditions
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.HorseNotepadComment>}
 */
const methodDescriptor_HorseService_CreateHorseNotepadComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/CreateHorseNotepadComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CreateHorseNotepadCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.HorseNotepadComment,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.HorseNotepadComment.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.HorseNotepadComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.HorseNotepadComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.createHorseNotepadComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/CreateHorseNotepadComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_CreateHorseNotepadComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.HorseNotepadComment>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.createHorseNotepadComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/CreateHorseNotepadComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_CreateHorseNotepadComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.HorseNotepadComment>}
 */
const methodDescriptor_HorseService_UpdateHorseNotepadComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/UpdateHorseNotepadComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.UpdateHorseNotepadCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.HorseNotepadComment,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.HorseNotepadComment.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.HorseNotepadComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.HorseNotepadComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.updateHorseNotepadComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UpdateHorseNotepadComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_UpdateHorseNotepadComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.HorseNotepadComment>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.updateHorseNotepadComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UpdateHorseNotepadComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_UpdateHorseNotepadComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse>}
 */
const methodDescriptor_HorseService_ListHorseNotepadComments =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ListHorseNotepadComments",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListHorseNotepadCommentsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListHorseNotepadCommentsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListHorseNotepadCommentsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.listHorseNotepadComments =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseNotepadComments",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListHorseNotepadComments,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.listHorseNotepadComments =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseNotepadComments",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListHorseNotepadComments
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_HorseService_DeleteHorseNotepadComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/DeleteHorseNotepadComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteHorseNotepadCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.deleteHorseNotepadComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/DeleteHorseNotepadComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_DeleteHorseNotepadComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.deleteHorseNotepadComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/DeleteHorseNotepadComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_DeleteHorseNotepadComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest,
 *   !proto.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse>}
 */
const methodDescriptor_HorseService_PullHorseAggregatedComments =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullHorseAggregatedComments",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullHorseAggregatedCommentsRequest,
    stronachgroup_first_racehorse360_messages_pb.PullHorseAggregatedCommentsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullHorseAggregatedCommentsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.pullHorseAggregatedComments =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorseAggregatedComments",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullHorseAggregatedComments,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.pullHorseAggregatedComments =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorseAggregatedComments",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullHorseAggregatedComments
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_HorseService_MarkHorseAggregatedCommentsAsRead =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/MarkHorseAggregatedCommentsAsRead",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.MarkHorseAggregatedCommentsAsReadRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.markHorseAggregatedCommentsAsRead =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/MarkHorseAggregatedCommentsAsRead",
      request,
      metadata || {},
      methodDescriptor_HorseService_MarkHorseAggregatedCommentsAsRead,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.markHorseAggregatedCommentsAsRead =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/MarkHorseAggregatedCommentsAsRead",
      request,
      metadata || {},
      methodDescriptor_HorseService_MarkHorseAggregatedCommentsAsRead
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.HorseGeneralVetComment>}
 */
const methodDescriptor_HorseService_CreateHorseGeneralVetComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/CreateHorseGeneralVetComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CreateHorseGeneralVetCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.HorseGeneralVetComment,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.HorseGeneralVetComment.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.HorseGeneralVetComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.HorseGeneralVetComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.createHorseGeneralVetComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/CreateHorseGeneralVetComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_CreateHorseGeneralVetComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.HorseGeneralVetComment>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.createHorseGeneralVetComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/CreateHorseGeneralVetComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_CreateHorseGeneralVetComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.HorseGeneralVetComment>}
 */
const methodDescriptor_HorseService_UpdateHorseGeneralVetComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/UpdateHorseGeneralVetComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.UpdateHorseGeneralVetCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.HorseGeneralVetComment,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.HorseGeneralVetComment.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.HorseGeneralVetComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.HorseGeneralVetComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.updateHorseGeneralVetComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UpdateHorseGeneralVetComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_UpdateHorseGeneralVetComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.HorseGeneralVetComment>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.updateHorseGeneralVetComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/UpdateHorseGeneralVetComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_UpdateHorseGeneralVetComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_HorseService_DeleteHorseGeneralVetComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/DeleteHorseGeneralVetComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteHorseGeneralVetCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.deleteHorseGeneralVetComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/DeleteHorseGeneralVetComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_DeleteHorseGeneralVetComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.deleteHorseGeneralVetComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/DeleteHorseGeneralVetComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_DeleteHorseGeneralVetComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.HorseGeneralVetComment>}
 */
const methodDescriptor_HorseService_GetHorseGeneralVetComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/GetHorseGeneralVetComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetHorseGeneralVetCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.HorseGeneralVetComment,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.HorseGeneralVetComment.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.HorseGeneralVetComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.HorseGeneralVetComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.getHorseGeneralVetComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/GetHorseGeneralVetComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_GetHorseGeneralVetComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.HorseGeneralVetComment>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.getHorseGeneralVetComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/GetHorseGeneralVetComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_GetHorseGeneralVetComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest,
 *   !proto.stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse>}
 */
const methodDescriptor_HorseService_PullHorsesOrTrainersByName =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullHorsesOrTrainersByName",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullHorsesOrTrainersRequest,
    stronachgroup_first_racehorse360_messages_pb.PullHorsesOrTrainersResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullHorsesOrTrainersResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.pullHorsesOrTrainersByName =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesOrTrainersByName",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullHorsesOrTrainersByName,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.pullHorsesOrTrainersByName =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesOrTrainersByName",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullHorsesOrTrainersByName
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_SetHorseFlagOnTrack =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/SetHorseFlagOnTrack",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.SetHorseFlagOnTrackRequest,
    stronachgroup_first_racehorse360_messages_pb.Horse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Horse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.setHorseFlagOnTrack =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/SetHorseFlagOnTrack",
      request,
      metadata || {},
      methodDescriptor_HorseService_SetHorseFlagOnTrack,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.setHorseFlagOnTrack =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/SetHorseFlagOnTrack",
      request,
      metadata || {},
      methodDescriptor_HorseService_SetHorseFlagOnTrack
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_EditHorseFlagOnTrack =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/EditHorseFlagOnTrack",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.EditHorseFlagOnTrackRequest,
    stronachgroup_first_racehorse360_messages_pb.Horse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Horse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.editHorseFlagOnTrack =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/EditHorseFlagOnTrack",
      request,
      metadata || {},
      methodDescriptor_HorseService_EditHorseFlagOnTrack,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.editHorseFlagOnTrack =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/EditHorseFlagOnTrack",
      request,
      metadata || {},
      methodDescriptor_HorseService_EditHorseFlagOnTrack
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest,
 *   !proto.stronachgroup.first.racehorse360.Horse>}
 */
const methodDescriptor_HorseService_ResetHorseFlagOnTrack =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ResetHorseFlagOnTrack",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ResetHorseFlagOnTrackRequest,
    stronachgroup_first_racehorse360_messages_pb.Horse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Horse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Horse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Horse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.resetHorseFlagOnTrack =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ResetHorseFlagOnTrack",
      request,
      metadata || {},
      methodDescriptor_HorseService_ResetHorseFlagOnTrack,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Horse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.resetHorseFlagOnTrack =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ResetHorseFlagOnTrack",
      request,
      metadata || {},
      methodDescriptor_HorseService_ResetHorseFlagOnTrack
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_HorseService_DeleteHorseFlagOnTrack =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/DeleteHorseFlagOnTrack",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteHorseFlagOnTrackRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.deleteHorseFlagOnTrack =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/DeleteHorseFlagOnTrack",
      request,
      metadata || {},
      methodDescriptor_HorseService_DeleteHorseFlagOnTrack,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.deleteHorseFlagOnTrack =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/DeleteHorseFlagOnTrack",
      request,
      metadata || {},
      methodDescriptor_HorseService_DeleteHorseFlagOnTrack
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.HorseFlagOnTrackComment>}
 */
const methodDescriptor_HorseService_GetHorseFlagOnTrackComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/GetHorseFlagOnTrackComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetHorseFlagOnTrackCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.HorseFlagOnTrackComment,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.HorseFlagOnTrackComment.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.HorseFlagOnTrackComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.HorseFlagOnTrackComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.getHorseFlagOnTrackComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/GetHorseFlagOnTrackComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_GetHorseFlagOnTrackComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.HorseFlagOnTrackComment>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.getHorseFlagOnTrackComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/GetHorseFlagOnTrackComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_GetHorseFlagOnTrackComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse>}
 */
const methodDescriptor_HorseService_ListHorseFlagOnTrackComments =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/ListHorseFlagOnTrackComments",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListHorseFlagOnTrackCommentsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListHorseFlagOnTrackCommentsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListHorseFlagOnTrackCommentsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.listHorseFlagOnTrackComments =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseFlagOnTrackComments",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListHorseFlagOnTrackComments,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.listHorseFlagOnTrackComments =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/ListHorseFlagOnTrackComments",
      request,
      metadata || {},
      methodDescriptor_HorseService_ListHorseFlagOnTrackComments
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_HorseService_DeleteHorseFlagOnTrackComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/DeleteHorseFlagOnTrackComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteHorseFlagOnTrackCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.deleteHorseFlagOnTrackComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/DeleteHorseFlagOnTrackComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_DeleteHorseFlagOnTrackComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.deleteHorseFlagOnTrackComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/DeleteHorseFlagOnTrackComment",
      request,
      metadata || {},
      methodDescriptor_HorseService_DeleteHorseFlagOnTrackComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest,
 *   !proto.stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse>}
 */
const methodDescriptor_HorseService_PullInventoryAnalytics =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullInventoryAnalytics",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullInventoryAnalyticsRequest,
    stronachgroup_first_racehorse360_messages_pb.PullInventoryAnalyticsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullInventoryAnalyticsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.pullInventoryAnalytics =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullInventoryAnalytics",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullInventoryAnalytics,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.pullInventoryAnalytics =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullInventoryAnalytics",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullInventoryAnalytics
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullHorsesShortInfoRequest,
 *   !proto.stronachgroup.first.racehorse360.PullHorsesShortInfoResponse>}
 */
const methodDescriptor_HorseService_PullHorsesShortInfo =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseService/PullHorsesShortInfo",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullHorsesShortInfoRequest,
    stronachgroup_first_racehorse360_messages_pb.PullHorsesShortInfoResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullHorsesShortInfoRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullHorsesShortInfoResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorsesShortInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullHorsesShortInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullHorsesShortInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.HorseServiceClient.prototype.pullHorsesShortInfo =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesShortInfo",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullHorsesShortInfo,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullHorsesShortInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullHorsesShortInfoResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.HorseServicePromiseClient.prototype.pullHorsesShortInfo =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseService/PullHorsesShortInfo",
      request,
      metadata || {},
      methodDescriptor_HorseService_PullHorsesShortInfo
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
